import { useDebouncedValue } from "@mantine/hooks"
import { useState } from "react"

export const useSearchSupplier = () => {
  const [supplierSearch, setSupplierSearch] = useState<string>("")
  const [debouncedSupplierSearch] = useDebouncedValue(supplierSearch, 250)

  return { supplierSearch, setSupplierSearch, debouncedSupplierSearch }
}
